
const nameStringFn = (userObject) =>{
    let fullName = "";
    if(userObject?.name?.middleName?.length){
        if(userObject?.name?.lastName?.length){
            fullName = `${userObject?.name?.firstName} ${userObject?.name?.middleName} ${userObject?.name?.lastName}`;
        }else{
            fullName = `${userObject?.name?.firstName} ${userObject?.name?.middleName}`;
        }
    }else if(userObject?.name?.lastName?.length){
        fullName = `${userObject?.name?.firstName} ${userObject?.name?.lastName}`;
    }else{
        fullName = `${userObject?.name?.firstName}`
    }
    return fullName;
}

export default nameStringFn